import { BaseChart } from "src/components/chart/chart";
import { RadarChartComponent } from "src/components/chart/radar_chart_component";
import { analysisTypes, Strings } from "src/constants";
import { IAnalyticData } from "src/features/analytic/data/models/patientAnalytic";
import { AnalyticHeader } from "./analyticHeader";

export class TotalAnalyticHeader extends AnalyticHeader {}
